/* Dog Armour — quick add desde la tarjeta premium y el upsell del carrito.
   Delegacion de eventos: sobrevive a los re-render AJAX de filtros/carrito. */
(function () {
  if (window.__darCardBound) return;
  window.__darCardBound = true;

  var CART = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/').replace(/\/$/, '') + '/cart';

  function toast(msg) {
    var el = document.querySelector('.dar-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'dar-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function openDrawer() {
    // Horizon: el drawer escucha su propio evento; si no, abrimos por el boton del header
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    // Si YA esta abierto no se toca el icono: ese boton es un toggle y lo cerraria.
    // Pasaba justo al anadir desde las sugerencias del propio carrito lateral.
    var abierto = document.querySelector('dialog#cart-drawer[open], #cart-drawer dialog[open], .page-wrapper--drawer-open');
    if (abierto) return;
    var opener = document.querySelector('[on\\:click*="cart"], .header-actions__cart-icon, [aria-controls*="cart-drawer"]');
    if (opener && typeof opener.click === 'function') opener.click();
  }

  /* Acordeon animado del upsell del carrito.
     El <details> nativo muestra/oculta de golpe; como el bloque esta anclado al fondo
     del drawer (margin-top:auto), ese salto se percibe como un rebote. Animamos la
     altura a mano y solo cambiamos `open` en el momento correcto. */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.dar-ups__head');
    if (!head) return;
    var det = head.closest('details.dar-ups');
    var list = det && det.querySelector('.dar-ups__list');
    if (!det || !list) return;

    e.preventDefault(); // controlamos nosotros la apertura
    if (det.dataset.animating === '1') return;

    if (reduce.matches) { det.open = !det.open; return; }

    var closing = det.open;
    det.dataset.animating = '1';

    // IMPORTANTE: `finish` APLICA el estado final, no solo limpia. Si el
    // transitionend no llega (pestana en segundo plano, sin composicion de
    // frames...), el temporizador de seguridad lo llama y el acordeon acaba
    // igualmente en el estado pedido. Antes solo limpiaba y NO cerraba.
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      clearTimeout(det.__t);
      list.removeEventListener('transitionend', onEnd);
      if (closing) det.open = false;
      list.style.height = '';        // volver a altura automatica
      det.dataset.animating = '';
    };
    var onEnd = function (ev) {
      if (ev.propertyName !== 'height') return;
      finish();
    };

    list.addEventListener('transitionend', onEnd);

    if (closing) {
      // CERRAR: de la altura actual a 0; `open` se quita al terminar
      list.style.height = list.scrollHeight + 'px';
      requestAnimationFrame(function () { list.style.height = '0px'; });
    } else {
      // ABRIR: `open` primero para poder medir, arrancar en 0 y animar al alto real
      det.open = true;
      var target = list.scrollHeight;
      list.style.height = '0px';
      requestAnimationFrame(function () { list.style.height = target + 'px'; });
    }

    det.__t = setTimeout(finish, 450); // red de seguridad
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dar-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-dar-add');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;

    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    fetch(CART + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.description) || 'error');
        toast('Added to cart');
        // avisar al tema para que refresque el carrito/contador
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'dar-card' } }));
        openDrawer();
      })
      .catch(function (err) {
        toast(String(err.message || err).slice(0, 90) || 'Could not add to cart');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      });
  });
})();
